import React, { useState, useEffect } from "react";
import { addNewAddress } from "../api";
import { toast } from "react-toastify";
import Modal from "../../../shared/ui/Modal";
import AddressForm from "./AddressForm";

const AddAddressModal = ({ isOpen, onClose, onSave, initialData, onEdit }) => {
  const isEditing = !!initialData;
  const [formData, setFormData] = useState({
    firstName: initialData?.firstName || "",
    lastName: initialData?.lastName || "",
    company: initialData?.company || "",
    address1: initialData?.address1 || "",
    address2: initialData?.address2 || "",
    city: initialData?.city || "",
    state: initialData?.state || "",
    postCode: initialData?.postCode || "",
    email: initialData?.email || "",
    phone: initialData?.phone || "",
    phone2: initialData?.phone2 || "",
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        firstName: initialData.firstName || "",
        lastName: initialData.lastName || "",
        company: initialData.company || "",
        address1: initialData.address1 || "",
        address2: initialData.address2 || "",
        city: initialData.city || "",
        state: initialData.state || "",
        postCode: initialData.postCode || "",
        email: initialData.email || "",
        phone: initialData.phone || "",
        phone2: initialData.phone2 || "",
      });
    }
  }, [initialData]);

  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [phone2Error, setPhone2Error] = useState(false);

  const handleDistrictChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      state: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "phone") {
      setPhoneError(value.length > 0 && !/^0\d{9}$/.test(value));
    }
    if (name === "phone2") {
      setPhone2Error(value.length > 0 && !/^0\d{9}$/.test(value));
    }
  };

  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      company: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      postCode: "",
      email: "",
      phone: "",
      phone2: "",
    });
    setPhoneError(false);
    setPhone2Error(false);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.state) {
      toast.error("Please select a district.");
      return;
    }

    if (!formData.phone || phoneError) {
      toast.error("Please enter a valid primary phone number.");
      return;
    }

    if (!formData.phone2 || phone2Error) {
      toast.error("Please enter a valid secondary phone number.");
      return;
    }

    setLoading(true);
    try {
      if (isEditing && onEdit) {
        await onEdit(formData);
        toast.success("Address updated successfully.");
        handleClose();
      } else {
        const savedAddress = await addNewAddress(formData);
        onSave(savedAddress);
        toast.success("Address saved successfully.");
        handleClose();
      }
    } catch (error) {
      console.error("Error saving address:", error.message);
      toast.error("Error saving address. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={isEditing ? "Edit address" : "Add new address"}
      size="lg"
      dismissible={!loading}
      footer={
        <>
          <button type="button" className="ui-btn ui-btn--ghost" onClick={handleClose} disabled={loading}>
            Cancel
          </button>
          <button type="submit" form="account-address-form" className="ui-btn ui-btn--primary" disabled={loading}>
            {loading ? (isEditing ? "Updating…" : "Saving…") : isEditing ? "Update address" : "Save address"}
          </button>
        </>
      }
    >
      <AddressForm
        formId="account-address-form"
        formData={formData}
        onChange={handleChange}
        onDistrictChange={handleDistrictChange}
        onSubmit={handleSubmit}
        phoneError={phoneError}
        phone2Error={phone2Error}
        districtPlaceholder="Select or search a district..."
      />
    </Modal>
  );
};

export default AddAddressModal;
